import { SurveyTemplate } from '@/surveys/state/types';

export const en = {
  assessments: {
    pageTitle: 'My Assessments',
    page: {
      title: '{{templateName}} assessment',
    },
    surveyNotCompleted: {
      title: 'Complete your assessments',
      steps: {
        title: 'Assessments to complete',
        description: {
          [SurveyTemplate.SoftSkillAssessment]:
            'A 15-minute questionnaire designed to measure key soft skills — such as creativity, problem solving, collaboration, and empathy — of your company and provide a personalized profile. The results allow you to identify strengths, improvement areas, and compare them with company trends.',
          [SurveyTemplate.HardSkillAssessment]:
            'A 15-minute questionnaire designed to measure the maturity level in generic technical skills related to AI management. The results allow you to identify strengths, improvement areas, and compare them with company trends.',
        },
        ctaLabel: 'Start assessment',
      },
      noSurvey: 'No assessments to complete at the moment.',
    },
    surveyResult: {
      title: 'Profile',
      description:
        'The chart shows your average score (scale 0-7) on the {{metricsCount}} {{surveyTemplateName}}, considered essential to effectively face AI challenges.',
      downloadAnswerGuide: 'Download Answer Guide',
      insightBox: {
        title: 'Insights',
        proTitle: 'Strengths',
        conTitle: 'Weaknesses',
      },
    },
    noResultVisible: {
      title: 'Assessment completed',
      description:
        'You have completed the assessment dedicated to evaluating the metrics of the {{surveyTemplateName}} assessment.\nExplore the available content and dive deeper into the areas that interest you most in the Training section.',
      buttonLabel: 'Explore training',
    },
    tutorial: {
      team: {
        title: 'Assessment Tutorial',
        slides: {
          slide1: {
            title: 'Take a look at your profile',
            description:
              'Check your hard skills profile and associated insights to understand the levels achieved, identify your strengths, and main areas for improvement.',
          },
          slide2: {
            title: 'Compare results with the team and department',
            description:
              'Check your hard skills profile and associated insights to understand the levels achieved, identify your strengths, and main areas for improvement.',
          },
        },
      },
      manager: {
        title: 'Assessment Tutorial',
        slides: {
          slide1: {
            title: 'Take a look at your profile',
            description:
              'Check your hard skills profile and associated insights to understand the levels achieved, identify your strengths, and main areas for improvement.',
          },
          slide2: {
            title: 'Compare results with the team and department',
            description:
              'Compare your score with the average of your department and the entire organization to contextualize the results and identify areas of alignment and growth opportunities.',
          },
        },
      },
      employee: {
        title: 'Assessment Tutorial',
        slides: {
          slide1: {
            title: 'Take a look at your profile',
            description:
              'Check your hard skills profile and associated insights to understand the levels achieved, identify your strengths, and main areas for improvement.',
          },
          slide2: {
            title: 'Compare results with the team',
            description:
              'Analyze the comparison between your scores and the team average to contextualize the results and understand where you are aligned and where you can grow.',
          },
        },
      },
    },
    resultsVsOrganization: {
      title: 'How do you position yourself in your organization?',
      description:
        'Comparison between your score and the average of your department and the entire organization.',
      labelTooltipChart:
        'Score: {{current}} pts\n\n{{depValue}} vs department average\n\n{{orgValue}} vs organization average',
      legend: {
        yourScore: 'Personal',
        depAverage: 'Department {{depName}} ({{total}} people)',
        orgAverage: 'Company ({{total}} people)',
      },
      insightBox: {
        title: 'Insights',
      },
    },
    resultsVsDepartmentAndTeam: {
      title: 'How do you position yourself in your department?',
      description:
        'Comparison between your score and the average of your team and your department.',
      labelTooltipChart:
        'Score: {{current}} pts\n\n{{depValue}} vs department average\n\n{{teamValue}} vs team average',
      legend: {
        yourScore: 'Personal',
        depAverage: 'Department {{depName}} ({{total}} people)',
        teamAverage: 'Team {{teamName}} ({{total}} people)',
      },
      insightBox: {
        title: 'Insights',
      },
    },
    resultsVsTeam: {
      title: 'How do you position yourself compared to your team?',
      description: 'Comparison between your score and the average of your team.',
      labelTooltipChart: 'Score: {{current}} pts\n\n{{teamValue}} vs team average',
      legend: {
        yourScore: 'Personal',
        teamAverage: 'Team {{teamName}} ({{total}} people)',
      },
      insightBox: {
        title: 'Insights',
      },
    },
  },
};
